import get from 'lodash/get';

export const selectWorkspaceActivity = (state) => get(state, 'preferences.workspaceActivity', []);
export const selectAutoSelectWs = (state) => get(state, 'preferences.autoSelectWs', false);
